import React, { createContext, useContext } from 'react';
import useNetworkHook from '../../hooks/Dashboard/useNetwork';

export const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
  const Network = useNetworkHook(); // Import everything from the hook

  return (
    <NetworkContext.Provider value={Network}>
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);